<template>
  <div>
    <ViewTemplateWithSalveCancel :panel="panel">
      <div slot="content-main">
        <Company />
      </div>
    </ViewTemplateWithSalveCancel>
  </div>
</template>

<script>
import ViewTemplateWithSalveCancel from "@nixweb/nixloc-ui/src/component/template/ViewTemplateWithSalveCancel";
import Company from "../../../components/modules/adm/company/Company.vue";

export default {
  name: "CompanyView",
  components: {
    ViewTemplateWithSalveCancel,
    Company,
  },
  data() {
    return {
      id: this.$route.params.id,
      panel: {
        module: "Adm",
        title: "Empresa",
        showFilter: false,
        showSearch: false,
        showButtons: false,
      },
    };
  },
};
</script>
